// extracted by mini-css-extract-plugin
module.exports = {"page":"Account_page_VMiFB","info":"Account_info_PcNxC","balance":"Account_balance_anwEq","freeze":"Account_freeze_19yrZ"};